<cac-dialog-layout [title]="data.product ? 'Edit Product' : 'Add New Product'"
    subtitle="Enter the required data and save" (onSubmit)="onSubmit($event)">
    <cac-form-builder [options]="basicForm" class="mt-5" />
    <div class="mt-5">
        <label for="colorPicker" class="block text-sm font-medium mb-2">Color</label>
        <div class="flex items-center gap-2">
            <input type="color" id="colorPicker" [formControl]="color"
                class="h-10 w-20 cursor-pointer border-0 rounded" />
            <input type="text" [formControl]="color" placeholder="#RRGGBB" class="border rounded px-3 py-2 w-32" />
        </div>
    </div>

    <div class="mt-8">
        <h2 class="text-lg font-medium mb-3">Related Cars</h2>
        <quill-editor [formControl]="descriptionsForm.controls.relatedCars"
            class="bg-white min-h-92 w-full"></quill-editor>
    </div>

    <div class="mt-8">
        <h2 class="text-lg font-medium mb-3">Other Description</h2>
        <quill-editor [formControl]="descriptionsForm.controls.otherDescription"
            class="bg-white min-h-92 w-full"></quill-editor>
    </div>

    <div class="mt-8">
        <h2 class="text-lg font-medium mb-3">Technical Description</h2>
        <quill-editor [formControl]="descriptionsForm.controls.technicalDescription"
            class="bg-white min-h-92 w-full"></quill-editor>
    </div>

    <div class="mt-8">
        <h2 class="text-lg font-medium mb-3">Technical Specification</h2>
        <quill-editor [formControl]="descriptionsForm.controls.technicalSpecification"
            class="bg-white min-h-92 w-full"></quill-editor>
    </div>

    <div class="gap-2 me-auto mt-5">
        <h1>Video</h1>
        <div class="flex items-center gap-2 mt-4">
            <cac-field [control]="videoForm.controls.video" controlType="file" label="Video"
                [loading]="isUploadVideoLoading()" [clearable]="true" />
            <cac-field [control]="videoForm.controls.videoTitle" controlType="input" label="Video Title" />

        </div>
        <cac-button (onClick)="openVideoInNewTab()" appearance="stroked"
            *ngIf="isProductFile(videoForm.controls.video.value)" class="w-60 float-left">
            Download Video
        </cac-button>
    </div>

    <div class="gap-2 me-auto mt-5">
        <h1>Document & 3D Model</h1>
        <div class="flex items-center gap-4 mt-4">
            <cac-field [control]="document" controlType="file" label="Document" [loading]="isUploadDocumentLoading()"
                [clearable]="true" class="flex-1" />
            <cac-field [control]="model" controlType="file" label="3D Model" [loading]="isUploadModelLoading()"
                [clearable]="true" class="flex-1" />
        </div>
        <div class="flex gap-4 mt-2">
            <div class="flex-1 flex">
                <cac-button (onClick)="openDocumentInNewTab()" appearance="stroked"
                    *ngIf="isProductFile(document.value)">
                    Download Document
                </cac-button>
            </div>
            <div class="flex-1 flex">
                <cac-button (onClick)="openModelInNewTab()" appearance="stroked" *ngIf="isProductFile(model.value)">
                    Download 3D Model
                </cac-button>
            </div>
        </div>
    </div>
    <cac-table [options]="imagesTable" class="mt-10" />
    <cac-table [options]="relatedProductsTable" class="mt-10" />
</cac-dialog-layout>
